import React from 'react';
import { Icon, Typography } from '@saviynt/design-system';

import './ErrorBanner.css';

interface ErrorBannerProps {
  message: string;
  fallBackMsg?: string;
  expanded?: boolean;
}

/**
 * Error Banner Component
 * Single responsibility: Display error messages
 */
function ErrorBanner({
  message,
  fallBackMsg,
  expanded = false,
}: ErrorBannerProps) {
  // Simple localization fallback - use fallBackMsg if provided, otherwise use message
  const displayMessage = fallBackMsg || message;

  const className = expanded
    ? 'Integrations-cua-ErrorBanner Integrations-cua-ErrorBanner--expanded'
    : 'Integrations-cua-ErrorBanner';

  return (
    <div className={className}>
      <Icon
        kind='AlertCriticalFilledSeparateColors'
        size='small'
        color='--color-foreground-critical-medium'
      />
      <Typography color='--color-foreground-critical-bold' kind='body-2'>
        {displayMessage}
      </Typography>
    </div>
  );
}

ErrorBanner.defaultProps = {
  fallBackMsg: '',
  expanded: false,
};

export default ErrorBanner;
